/**
 * Cart helpers:
 * - restore qty UI
 * - sync / clear hidden "Custom Cut" fee lines (variant 42731011014884)
 *
 * Fee rows are CSS-hidden (.cut-product-item { display:none }), so when sheets
 * are removed the fee can remain and still show in cart total (e.g. 4 × $3.50 = $14).
 */
(function () {
  var CUT_VARIANT_ID = 42731011014884;

  function ensureQuantityInputsVisible() {
    var cells = document.querySelectorAll(".cart__cell--quantity");
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      if (cell.querySelector(".js-qty")) continue;
      var input = cell.querySelector('input[name="updates[]"]');
      if (!input) continue;
      input.classList.add("cart__quantity");
    }
  }

  function restoreThemeCart() {
    if (!window.themeLodash || typeof window.themeLodash.map !== "function") return false;
    window._ = window.themeLodash;
    if (!window.jQuery || !window.theme || !theme.Cart) return false;
    var $container = window.jQuery('[data-section-type="cart"]');
    if (!$container.length) return false;
    try {
      new theme.Cart($container[0]);
      return true;
    } catch (error) {
      return false;
    }
  }

  function countRequiredCutFees(cart) {
    var needed = 0;
    (cart.items || []).forEach(function (item) {
      if (Number(item.id) === CUT_VARIANT_ID) return;
      var props = item.properties || {};
      Object.keys(props).forEach(function (key) {
        if (key.indexOf("Custom Cut:") !== 0) return;
        var n = Number(props[key]);
        if (isFinite(n) && n > 0) needed += n;
      });
    });
    return needed;
  }

  function countCurrentCutFees(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (Number(item.id) === CUT_VARIANT_ID) total += Number(item.quantity) || 0;
    });
    return total;
  }

  /** Set cut-fee quantity to match remaining custom-cut properties (0 clears orphans). */
  function syncCutFeeQuantity(done) {
    if (typeof window.jQuery === "undefined") {
      if (done) done(false);
      return;
    }
    var $ = window.jQuery;
    $.getJSON("/cart.js")
      .done(function (cart) {
        var needed = countRequiredCutFees(cart);
        var current = countCurrentCutFees(cart);
        if (current === needed) {
          if (done) done(false);
          return;
        }
        // Absolute qty update for the fee variant
        var payload = {};
        payload["updates[" + CUT_VARIANT_ID + "]"] = needed;
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: payload,
          success: function () {
            if (done) done(true);
          },
          error: function () {
            // Fallback: change.js by variant id
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              dataType: "json",
              data: { id: CUT_VARIANT_ID, quantity: needed },
              complete: function () {
                if (done) done(true);
              },
            });
          },
        });
      })
      .fail(function () {
        if (done) done(false);
      });
  }

  function onCartPage() {
    return (
      document.body.classList.contains("template-cart") ||
      !!document.querySelector('[data-section-type="cart"]')
    );
  }

  function fixCart() {
    restoreThemeCart();
    ensureQuantityInputsVisible();
  }

  function scheduleFix() {
    fixCart();
    setTimeout(fixCart, 300);
    setTimeout(fixCart, 1500);
    setTimeout(fixCart, 3000);
  }

  /**
   * custom.js remove-item always fires a second /cart/change for the cut-fee
   * variant. On sheet-only carts that second call uses NaN qty and never
   * reloads — item is removed server-side but the UI stays stale.
   * Replace that handler (this file loads after custom.js on cart pages).
   */
  function patchRemoveItemHandler() {
    if (typeof window.jQuery === "undefined") return false;
    var $ = window.jQuery;
    $(document).off("click", ".remove-item");
    $(document).on("click.falkenCartRemove", ".remove-item", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $btn = $(this);
      if ($btn.data("removing")) return;
      $btn.data("removing", true);

      var itemLine = $btn.data("item-line");
      var itemQty = Number($btn.data("item-qty")) || 0;
      var $cut = $(".cut-product-item");
      var cutQty = Number($cut.data("qty")) || 0;

      function reloadCart() {
        window.location.href = "/cart";
      }

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: { line: itemLine, quantity: 0 },
      })
        .done(function () {
          if (itemQty > 0 && $cut.length && cutQty > 0) {
            var qty = Math.max(0, cutQty - itemQty);
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              dataType: "json",
              data: { id: CUT_VARIANT_ID, quantity: qty },
            }).always(reloadCart);
          } else if (typeof window.falkenSyncCutFeeInCart === "function") {
            window.falkenSyncCutFeeInCart(function () {
              reloadCart();
            });
          } else {
            reloadCart();
          }
        })
        .fail(reloadCart);
    });
    return true;
  }

  function initCutFeeSync() {
    if (!onCartPage()) return;

    patchRemoveItemHandler();
    window.setTimeout(patchRemoveItemHandler, 300);
    window.setTimeout(patchRemoveItemHandler, 1500);

    syncCutFeeQuantity(function (changed) {
      if (changed) window.location.reload();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleFix();
      initCutFeeSync();
    });
  } else {
    scheduleFix();
    initCutFeeSync();
  }
  window.addEventListener("load", function () {
    fixCart();
    initCutFeeSync();
  });

  // Expose for debugging / other scripts
  window.falkenSyncCutFeeInCart = syncCutFeeQuantity;
})();
